import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import RedirectHandler from "./components/RedirectHandler";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="relative min-h-screen bg-stone-50 text-stone-900 antialiased flex flex-col justify-between">
      {/* Scroll to top on navigation */}
      <ScrollToTop />

      {/* 301 Redirect Handler */}
      <RedirectHandler />

      {/* Header Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Danish Routes (Standard Primary) */}
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/totalentreprise" element={<ServiceDetail fixedSlug="totalentreprise" />} />
          <Route path="/projektering-af-byggeri" element={<ServiceDetail fixedSlug="projektering-af-byggeri" />} />
          <Route path="/toemrerarbejde" element={<ServiceDetail fixedSlug="toemrerarbejde" />} />
          <Route path="/renovering" element={<ServiceDetail fixedSlug="renovering" />} />
          <Route path="/totalrenovering" element={<ServiceDetail fixedSlug="totalrenovering" />} />
          <Route path="/byggepladsservice" element={<ServiceDetail fixedSlug="byggepladsservice" />} />
          <Route path="/specialprojekter" element={<ServiceDetail fixedSlug="specialprojekter" />} />
          <Route path="/byggeprojekt" element={<ServiceDetail fixedSlug="byggeprojekt" />} />
          <Route path="/haandvaerker-byggeprojekt" element={<ServiceDetail fixedSlug="haandvaerker-byggeprojekt" />} />
          <Route path="/haandvaerker" element={<ServiceDetail fixedSlug="haandvaerker-byggeprojekt" />} />
          <Route path="/projekter" element={<Projects />} />
          <Route path="/projekter/:slug" element={<ProjectDetail />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* English Routes */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/services" element={<Services />} />
          <Route path="/en/services/:slug" element={<ServiceDetail />} />
          <Route path="/en/turnkey" element={<ServiceDetail fixedSlug="turnkey" />} />
          <Route path="/en/building-engineering" element={<ServiceDetail fixedSlug="building-engineering" />} />
          <Route path="/en/carpentry" element={<ServiceDetail fixedSlug="carpentry" />} />
          <Route path="/en/renovation" element={<ServiceDetail fixedSlug="renovation" />} />
          <Route path="/en/total-renovation" element={<ServiceDetail fixedSlug="total-renovation" />} />
          <Route path="/en/construction-site-services" element={<ServiceDetail fixedSlug="construction-site-services" />} />
          <Route path="/en/site-services" element={<ServiceDetail fixedSlug="site-services" />} />
          <Route path="/en/custom-projects" element={<ServiceDetail fixedSlug="custom-projects" />} />
          <Route path="/en/construction-projects" element={<ServiceDetail fixedSlug="construction-projects" />} />
          <Route path="/en/trades-construction-projects" element={<ServiceDetail fixedSlug="trades-construction-projects" />} />
          <Route path="/en/trades" element={<ServiceDetail fixedSlug="trades-construction-projects" />} />
          <Route path="/en/projects" element={<Projects />} />
          <Route path="/en/projects/:slug" element={<ProjectDetail />} />
          <Route path="/en/about" element={<About />} />
          <Route path="/en/contact" element={<Contact />} />

          {/* Fallback redirect or handling can be done here if needed */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
